<template>
  <div class="main">
    <headlogin></headlogin>
    <div class="content">
      <div class="cons">
        <div class="login-title">
          <div class="login-title-wz">注册账号</div>
        </div>
        <div class="login-con">
          <el-form
            :label-position="'top'"
            label-width="200px"
            :model="formLabelAlign"
            :rules="baseRules"
            ref="ruleFormRef"
          >
            <el-form-item label="手机号" required prop="usertel">
              <el-input
                v-model="formLabelAlign.usertel"
                placeholder="请输入您的手机号"
              />
            </el-form-item>
            <el-form-item label="验证码" required prop="code">
              <el-input
                v-model="formLabelAlign.code"
                placeholder="请输入验证码"
              >
                <template #append>
                  <el-button type="primary" @click="clickgetcode"
                    >获取验证码</el-button
                  >
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="密码" required prop="password">
              <el-input
                type="password"
                v-model="formLabelAlign.password"
                show-password
                placeholder="请设置密码"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit(ruleFormRef)"
                >立即注册</el-button
              >
              <el-button @click="onzc">登录系统</el-button>
              <el-button @click="onshouye">返回首页</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script setup>
import { post, get } from "@/utils/index";
import { ElMessage } from "element-plus";
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();

let formLabelAlign = reactive({
  username: "",
  password: "",
  realname: "",
  usertel: "",
  code: "",
});
const ruleFormRef = ref();
const baseRules = {
  password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
  usertel: [{ required: true, message: "手机号不能为空", trigger: "blur" }],
  code: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
};

const onSubmit = (formEl) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    // 通过验证规则 true
    if (valid) {
      formLabelAlign.username = formLabelAlign.usertel; //默认真实姓名为用户名
      formLabelAlign.realname = formLabelAlign.usertel; //默认真实姓名为用户名
      post("/api/UserLogin/Reg", formLabelAlign).then((result) => {
        ElMessage({
          type: "success",
          message: "注册成功",
          duration: 1000,
          onClose: () => {
            //直接登录
            post("/api/UserLogin/Login", formLabelAlign).then((res) => {
              // 保存token
              window.localStorage.setItem("token", res.data);
              // 保存用户名到本地
              window.localStorage.setItem("username", formLabelAlign.username);
              // 存在地址则跳回
              if (
                window.localStorage.getItem("loginurl") &&
                window.localStorage.getItem("loginurl") != ""
              ) {
                window.location.href = window.localStorage.getItem("loginurl");
              } else {
                router.push({
                  path: "/",
                  query: {},
                });
              }
            });
            //跳转登录页
            //   router.push({
            //     path: "/login",
            //     query: {},
            //   });
          },
        });
      });
    }
  });
};

// 获取验证码
const clickgetcode = () => {
  get("/api/UserLogin/RegSendPhoneCode", { p: formLabelAlign.usertel }).then(
    (result) => {
      ElMessage({
          type: "success",
          message: "发送成功，5分钟内有效。",
      });
    }
  );
};

// 登录
const onzc = () => {
  router.push({
    path: "/login",
    query: {},
  });
};
// 返回首页
const onshouye = () => {
  router.push({
    path: "/",
    query: {},
  });
};
</script>

<style scoped>
.main {
  background: #fff;
}
.content {
  width: 1200px;
  height: auto;
  margin: auto;
}
.cons {
  width: 600px;
  margin: auto;
  height: 500px;
  padding: 30px 0;
}
.login-title {
  border-bottom: 1px solid #666;
  padding: 20px 0;
  margin-bottom: 30px;
}
.login-title-wz {
  font-size: 24px;
  text-align: center;
}
</style>
